module.exports = __webpack_public_path__ + "img/delimg.1e054df9.svg";